import React, { memo } from 'react'

import { Button, Icon, DotsVertical } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

const dotsIcon = <Icon svgComponent={DotsVertical} color="dark" size="small" notSpaced />

function DccRowTrigger({ softwareName, disabled = false }) {
  return (
    <Button
      icon={dotsIcon}
      type="ghost"
      size="small"
      variant="only-icon"
      aria-label={`${softwareName} options`}
      disabled={disabled}
      customClass="dcc-bridge-popover__row-trigger"
    />
  )
}

DccRowTrigger.propTypes = {
  softwareName: string.isRequired,
  disabled: bool,
}

export default memo(DccRowTrigger)
